// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"e_Eo","title":"e_Fo","container":"e_Go","list":"e_Ho"};